import { render, staticRenderFns } from "./ConfigureGroup.vue?vue&type=template&id=3a5ff1a9&"
import script from "./ConfigureGroup.vue?vue&type=script&lang=js&"
export * from "./ConfigureGroup.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports